import * as React from 'react';
import { Result } from './result';
import { ISearchResultHitDTO } from '../../DTO/search';
import { IContentProps } from '../../models/content-props';

interface IProps {
    totalResults: number;
    currentPageResults: number;
    content: IContentProps;
    pageSize: number;
    currentPage: number;
    isLoading: boolean;
}

export class ResultCount extends React.Component<IProps, any> {
    get resultsText() {
        const { totalResults, currentPageResults, pageSize, currentPage, isLoading, content } = this.props;

        return this.getResultsText(totalResults, currentPageResults, pageSize, currentPage, isLoading, content.loadingResultsText, content.zeroResultsText, content.numberOfResultsText);
    }

    render() {
        return (
            <p className="directory-block-key light-cyan h6-style">
                {this.resultsText}
            </p>
        );
    }

    getResultsText = (totalResults: number,
        pageResults: number,
        pageSize: number,
        currentPage: number,
        isLoading: boolean,
        loadingResultsText: string,
        zeroResultsText: string,
        amountOfResultsText: string) => {
        let resultsText: string;

        if (isLoading) {
            resultsText = loadingResultsText;
        } else if (totalResults == 0 || (totalResults <= pageSize * (currentPage - 1))) {
            // Show Zero Results message if no results or out of range
            resultsText = zeroResultsText;
        } else {
            let rangeFirst = ((currentPage - 1) * pageSize) + 1;
            let rangeLast = totalResults < pageSize ? totalResults : rangeFirst + pageResults - 1;
            let rangeStr = (rangeFirst == rangeLast) ? rangeFirst.toString() : `${rangeFirst.toString()} - ${rangeLast.toString()}`;
            resultsText = amountOfResultsText.replace("{total}", totalResults.toString()).replace("{page}", rangeStr);
        }
        return resultsText;
    }
}

